<div class="mb-20" *ngIf="showHeader">{{'generic.components.timer.playPause' | translate}}</div>

<div class="row">
    <i class="material-icons text-grey"
      [class.hidden]="state==='stop' && !showWhenStopped"
      [class.text-red]="showStandardTime && (elapsedTime > standardTime || elapsedTime < 0)"
      [class.muted]="state==='stop' && showWhenStopped"
    >timer</i>
    <div class="text-column"
         [class.hidden]="state==='stop' && !showWhenStopped"
         [class.muted]="state==='stop' && showWhenStopped">
      <strong class="text-grey"
             [class.text-red]="showStandardTime && (elapsedTime > standardTime || elapsedTime < 0)"
      >{{elapsedTime < 0 ? "-" : ""}}{{hours(abs(elapsedTime))}}:{{abs(elapsedTime) | date: 'mm:ss'}}</strong>
      <p class="text-blue"
        [class.text-red]="showStandardTime && (elapsedTime > standardTime || elapsedTime < 0)"
      >{{ 'generic.components.timer.elapsedTime' | translate }}</p>
    </div>

    <ng-container *ngIf="showStandardTime">
      <i class="fa fa-clock-o text-blue ml-35" [class.muted]="state==='stop' && showWhenStopped"></i>
      <div class="text-column text-blue" [class.muted]="state==='stop' && showWhenStopped">
        <strong>{{hours(standardTime)}}:{{standardTime | date: 'mm:ss'}}</strong>
        <p>{{ 'generic.components.timer.standardTime' | translate }}</p>
      </div>
    </ng-container>
    <div *ngIf="showControls" >
      <i class="fa ml-25 text-blue"
        [class.fa-play-circle]="state==='stop' || state==='pause'"
        [class.fa-pause-circle]="state==='start' && canPause"
        (click)="state==='start' ? onPauseTimer() : onStartTimer()">
      </i>
      <i *ngIf="(state==='start' || state==='pause') && canStop" (click)="onStopTimer()"
          class="fa fa-stop-circle text-blue">
      </i>
    </div>
</div>
